(() => {
  'use strict';
  const node = document.getElementById('mifo-reviews-config');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const productId = String(config.productId || '');
  const isProduct = /^[1-9]\d*$/.test(productId);
  const isGen4 = config.handle === 'mifo-gen-4-wireless-earbuds';
  let modulePromise;
  let opening = false;
  let frame = 0;
  const handled = new WeakSet();

  function scope(trigger) {
    const widget = trigger.closest('.jdgm-preview-badge[data-id],.jdgm-review-widget[data-id]');
    const id = trigger.dataset.mifoReviewProduct || widget?.dataset.id || productId;
    if (!/^[1-9]\d*$/.test(id)) return null;
    const family = isGen4 && id === productId;
    return { productId: family ? '2295061217376' : id, title: config.title || 'Customer reviews',
      reviewLabel: family ? 'O5 family reviews' : 'customer reviews',
      price: id === productId ? config.price : '', logoUrl: config.logoUrl };
  }
  function returnToProduct(trigger) {
    const button = document.querySelector('#mifo-gen4-root .hero-add, [id^="ProductSubmitButton"], form[action*="/cart/add"] button[type="submit"]');
    const destination = button || document.querySelector('[id^="ProductInfo"], #mifo-gen4-root .hero') || trigger;
    destination?.scrollIntoView({ behavior: 'auto', block: 'center' });
    if (destination && !destination.disabled) destination.focus({ preventScroll: true });
  }
  async function open(trigger) {
    const context = scope(trigger);
    if (!context || opening) return;
    opening = true;
    trigger.setAttribute('aria-busy', 'true');
    try {
      modulePromise ||= import(config.moduleUrl);
      const module = await modulePromise;
      module.openReviews({ ...context, onReturn: () => returnToProduct(trigger) });
    } catch {
      modulePromise = null;
      document.querySelectorAll('[data-mifo-review-replaced]').forEach(el => el.removeAttribute('data-mifo-review-replaced'));
      const original = document.getElementById('judgeme_product_reviews');
      if (original) original.scrollIntoView({ behavior: 'auto', block: 'start' });
      const status = document.getElementById('mifo-reviews-load-status');
      if (status) status.textContent = 'Reviews could not load. Please try again.';
    } finally { opening = false; trigger.removeAttribute('aria-busy'); }
  }
  function triggerFor(event) {
    if (!(event.target instanceof Element) || event.target.closest('.jdgm-qa-badge')) return null;
    return event.target.closest('[data-mifo-open-reviews], .jdgm-preview-badge .jdgm-prev-badge__stars, .jdgm-preview-badge .jdgm-prev-badge__text, a[href="#judgeme_product_reviews"]');
  }
  document.addEventListener('click', event => {
    const trigger = triggerFor(event);
    if (!trigger || !scope(trigger)) return;
    event.preventDefault(); event.stopImmediatePropagation(); open(trigger);
  }, true);
  document.addEventListener('keydown', event => {
    if (!['Enter', ' '].includes(event.key)) return;
    const trigger = triggerFor(event);
    if (!trigger || !scope(trigger) || trigger.tagName === 'BUTTON') return;
    event.preventDefault(); event.stopImmediatePropagation(); open(trigger);
  }, true);

  function addButton(container, id, text = 'Read all reviews') {
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'mifo-reviews-open'; button.textContent = text;
    button.dataset.mifoOpenReviews = ''; button.dataset.mifoReviewProduct = id;
    button.setAttribute('aria-haspopup', 'dialog');
    container.append(button);
    return button;
  }
  function enhance() {
    frame = 0;
    if (!isProduct) return;
    for (const widget of document.querySelectorAll('.jdgm-review-widget[data-id]')) {
      if (handled.has(widget)) continue;
      handled.add(widget);
      const panel = document.createElement('section'); panel.className = 'mifo-reviews-entry';
      panel.setAttribute('aria-label', 'Customer reviews');
      const copy = document.createElement('div');
      const title = document.createElement('h2'); title.textContent = 'Mifo, in your words.'; copy.append(title);
      const logo = document.createElement('img'); logo.src = config.logoUrl; logo.alt = 'Reviews collected by Judge.me'; logo.width = 125; logo.height = 24; copy.append(logo);
      panel.append(copy); addButton(panel, widget.dataset.id);
      widget.before(panel); widget.dataset.mifoReviewReplaced = '';
    }
    for (const badge of document.querySelectorAll('.jdgm-preview-badge[data-id] .jdgm-prev-badge__text')) {
      if (handled.has(badge)) continue;
      handled.add(badge); badge.setAttribute('role', 'button'); badge.setAttribute('tabindex', '0'); badge.setAttribute('aria-haspopup', 'dialog');
    }
    if (isGen4) {
      for (const rating of document.querySelectorAll('#mifo-gen4-root .hero-rating, #mifo-gen4-root .proof-rating')) {
        if (handled.has(rating)) continue;
        handled.add(rating); rating.dataset.mifoOpenReviews = ''; rating.setAttribute('role', 'button'); rating.setAttribute('tabindex', '0'); rating.setAttribute('aria-haspopup', 'dialog');
        const label = document.createElement('span'); label.className = 'mifo-reviews-rating-label'; label.textContent = 'Read reviews'; rating.append(label);
      }
      const copy = document.querySelector('#mifo-gen4-root .review-copy');
      if (copy && !copy.querySelector('[data-mifo-open-reviews]')) addButton(copy, productId);
    } else if (!document.querySelector('.jdgm-preview-badge, .mifo-reviews-open')) {
      const info = document.querySelector('[id^="ProductInfo"] h1');
      if (info && !handled.has(info)) { handled.add(info); const wrapper = document.createElement('div'); addButton(wrapper, productId, 'Read customer reviews'); info.after(wrapper); }
    }
  }
  enhance();
  const observer = new MutationObserver(records => {
    if (frame || !records.some(record => [...record.addedNodes].some(n => n instanceof Element && !n.closest('#mifo-reviews-root')))) return;
    frame = requestAnimationFrame(enhance);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
